var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_411_9339)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_411_9339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.52588e-05 0.5H18V13.5H1.52588e-05V0.5Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.10939 0.5L8.97189 5.40208L15.8063 0.5H18V2.17917L11.25 7.02708L18 11.8479V13.5H15.75L9.00002 8.65208L2.27814 13.5H1.52588e-05V11.875L6.72189 7.05417L1.52588e-05 2.23333V0.5H2.10939Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.925 8.11042L18 12.4167V13.5L10.3781 8.11042H11.925ZM6.75002 8.65208L6.91877 9.6L1.51877 13.5H1.52588e-05L6.75002 8.65208ZM18 0.5V0.58125L10.9969 5.67292L11.0531 4.48125L16.5938 0.5H18ZM1.52588e-05 0.5L6.72189 5.26667H5.03439L1.52588e-05 1.6375V0.5Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.77814 0.5V13.5H11.2781V0.5H6.77814ZM1.52588e-05 4.83333V9.16667H18V4.83333H1.52588e-05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.52588e-05 5.72708V8.32708H18V5.72708H1.52588e-05ZM7.67814 0.5V13.5H10.3781V0.5H7.67814Z",
    fill: "#C8102E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_411_9339"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 14,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_411_9339"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 13,
    fill: "white",
    transform: "translate(1.52588e-05 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagEn);
export default __webpack_public_path__ + "static/media/flagEN.d1770c5e06ef5aab902d89d7819ea413.svg";
export { ForwardRef as ReactComponent };